import { getPath as n } from "./index357.mjs";
import { setPath as f } from "./index350.mjs";
function u(t, o, r) {
  const e = n(t, r);
  return Array.isArray(e) ? f(t, e.filter((m, i) => i !== o), r) : r;
}
export {
  u as removePath
};
